import React from 'react';
import { Typography } from 'fronton-react';
import { formatToRu, roundNumber } from 'utils';
import { useTranslation } from 'react-i18next';
import { wrapper } from './styles';

type Props = {
  qty: number | undefined;
  boxPrice?: number;
  boxVolume: number | null;
};

export const VisualizeBoxes = ({ qty, boxPrice, boxVolume }: Props) => {
  const { t } = useTranslation();
  if (!qty || !boxPrice || !boxVolume) {
    return null;
  }
  return (
    <div className={wrapper} data-qa="vb">
      <Typography variant="caption" data-qa="vb-left">
        {qty} {t('ui.box')} = {formatToRu(roundNumber(boxVolume * qty, 1))} {t('ui.m2')}
      </Typography>
      <Typography variant="caption_accent" data-qa="vb-right">
        = {formatToRu(roundNumber(qty * boxPrice, 2))} {t('ui.currency')}
      </Typography>
    </div>
  );
};
